import { LinkItem, TranslateRawFn } from '@mi-front/ui';

export function getAuditGlobalReportsLinks(formatMessage: TranslateRawFn): readonly LinkItem[] {
  return [
    {
      to: `/audit/global-reports/gip-report`,
      text: formatMessage({
        id: 'audit.gipReport.title',
        defaultMessage: 'GIP report',
      }),
    },
    {
      to: `/audit/global-reports/gip-alternative-report`,
      text: 'GIP alternative',
    },
    {
      to: `/audit/global-reports/missing-media`,
      text: formatMessage({
        id: 'audit.missingAudios.title',
        defaultMessage: 'Media faltante',
      }),
    },
    {
      to: `/audit/global-reports/no-matches`,
      text: formatMessage({
        id: 'audit.reportsScreen.noMatches.title',
        defaultMessage: 'Media sin matches',
      }),
    },
    {
      to: `/audit/global-reports/schedules-no-matches`,
      text: formatMessage({
        id: 'audit.schedulesNoMatches.title',
        defaultMessage: 'Schedules sin matches',
      }),
    },
    {
      to: `/audit/global-reports/consecutive-schedules`,
      text: formatMessage({
        id: 'audit.consecutiveSchedules.title',
        defaultMessage: 'Schedules consecutivos',
      }),
    },
    {
      to: `/audit/global-reports/lowerthird`,
      text: formatMessage({
        id: 'audit.lowerthird.title',
        defaultMessage: 'Zocalos',
      }),
    },
  ];
}
